<div class="loren-language-switcher-button-container">
  <button
    class="loren-language-switcher-button"
    [tourAnchor]="languageAnchorId"
    [matTooltip]="'tooltips.change_language' | transloco"
    (click)="selectLanguage(newLanguage())">
    <mat-icon
      class="loren-language-switcher-button-icon"
      [svgIcon]="currentLanguage().toLowerCase()">
    </mat-icon>
    @if(!isHandset) {
    <span class="loren-language-switcher-button-text">{{
      currentLanguage().toUpperCase()
    }}</span>
    }
  </button>
</div>
